import { Project } from '../types/Project';

export const projects: Project[] = [
  {
    id: 'bread-and-butter',
    videoUrl: 'videos/breadandbutter_master.mp4',
    title: 'BREAD AND BUTTER',
    subtitle: '',
    services: [
      'Composition',
      'Sound Design'
    ],
    client: '0711 Livecom GmbH',
    small: false
  },
  {
    id: 'reach-vr-ar',
    videoUrl: 'videos/reach_master.mp4',
    title: 'REACH (VR / AR)',
    subtitle: '',
    link: 'https://untold.garden/reach/',
    linkTitle: 'MORE',
    services: [
      'Sound Design',
      'Composition',
      'Mixing'
    ],
    client: 'Partners: Max Celar · Marcel Müller',
    small: true
  },
  {
    id: 'bmw-vision-shanghai',
    videoUrl: 'videos/bmw_shanghai_master.mp4',
    title: 'BMW Vision Driving Experience – Auto Show Shanghai',
    subtitle: '',
    services: [
      'Sound Design'
    ],
    client: 'Awesome Pixels / Klangerfinder',
    small: false
  },
  {
    id: 'hyundai',
    videoUrl: 'videos/hyundai_master.mp4',
    title: 'Hyundai x Florian Ostertag (Berlin Fashion Week 2025)',
    subtitle: '',
    services: [
      'Sound Design',
      'Mixing',
      'Mastering',
    ],
    client: 'Awesome Pixels',
    small: true
  },
  {
    id: 'dj',
    videoUrl: 'videos/dj_master.mp4',
    title: 'DJ VITA',
    subtitle: 'From smashing the decks at HipHop Open, celebrating 30 years of Die Fantastischen Vier, and tearing it up at Schräglage (solo sets plus supporting heavyweights like Haftbefehl, Chefket, Die Beginner, Marteria, Die Orsons and more), to keeping vibes lit at Tatti (New Year’s Eve blowouts & Christmas shindigs included), Rocker33, Climaxx, and even repping at Porsche’s 75th anniversary bash on the Hockenheimring with Paul Ripke. Add the Mercedes-Benz Executive Events, The Porsche Tunnel Club at home games from VfB Stuttgart countless birthdays and weddings, and a whole lot more – every single one still gives me a buzz and keeps me hyped for the next set.',
    services: [
    ],
    link: 'mailto:l.crvadiku@0711.net',
    linkTitle: 'Booking',
    client: '',
    small: false
  },
  {
    id: 'edits',
    videoUrl: 'videos/edits_darker_master.mp4',
    title: 'sumolicious edits vol. 1',
    subtitle: 'Edits of: Migos, Bad Bunny, OG Keemo, Mashine Gun Kelly, IAMDDB, Jonwayne',
    services: [
      'Composition',
      'Production',
      'Mixing'
    ],
    link: 'https://soundcloud.com/sumo0711/sets/sumolicious-edits-vol-1',
    linkTitle: 'LISTEN',
    client: 'Partners: finji, KITI ARSA, Swight Dultz',
    small: false
  },
  {
    id: 'db-ise-25',
    videoUrl: 'videos/dbISE25_master.mp4',
    title: 'd&b ISE 25',
    subtitle: '',
    services: [
      'Sound Design',
      'Composition',
      'AI Voice'
    ],
    client: 'd&b / Klangerfinder',
    small: true
  },
  {
    id: 'dmg-mori-emo',
    videoUrl: 'videos/dmgmori_master.mp4',
    title: 'DMG MORI – EMO 2024 Hannover',
    subtitle: '',
    services: [
      'Composition',
      'Sound Design',
      '5.1 On-Site Mixing'
    ],
    client: 'Jangled Nerves / Klangerfinder',
    small: true
  },
  {
    id: 'freundeskreis-tracks',
    videoUrl: 'videos/freundeskreis_master.mp4',
    title: 'Freundeskreis',
    subtitle: 'Leg dein Ohr auf die Schiene der Geschichte',
    link: 'https://www.stadtpalais-stuttgart.de/ausstellungen/leg-dein-ohr-auf-die-schiene-der-geschichte',
    linkTitle: 'More',
    services: [
      'Editing',
      'Sound Design',
      'Composition',
      'Mixing for usomo (binaural audio system)'
    ],
    client: 'StadtPalais – Museum für Stuttgart',
    small: false
  },
  {
    id: 'rillencheck',
    videoUrl: 'videos/rillencheck_master.mp4',
    title: 'Rillencheck Season 2 & 3',
    subtitle: '',
    services: [
      'Founder',
      'Creative Direction',
      'Moderation',
    ],
    client: 'Mercedes Benz, Jägermeister, Saeed Kakavand',
    small: false
  },
  {
    id: 'beyerdynamic-launch',
    videoUrl: 'videos/beyerdynamic_master.mp4',
    title: 'beyerdynamic Launch Campaign',
    subtitle: 'DT 770 PRO X & DT 990 PRO X',
    services: [
      'Music Composition',
      'Sound Design',
      'Casting & Voice Recording'
    ],
    client: 'beyerdynamic · 0711 Livecom GmbH',
    small: true
  },
  {
    id: 'blind-date-stuttgart',
    videoUrl: 'videos/blinddatemitstuttgart_master.mp4',
    title: 'Blind Date mit Stuttgart',
    subtitle: 'Sound Installations for an Inclusive Urban Experience',
    services: [
      'Technical Concept',
      'Installation & System Integration',
      'Interactive Sound Scenes via IR Sensor',
      'Sound Design'
    ],
    client: 'StadtPalais – Museum für Stuttgart',
    small: false
  },
  {
    id: 'ghost-autonomy',
    videoUrl: 'videos/ghost_master.mp4',
    title: 'Ghost Autonomy – Semantic Audio System',
    subtitle: '',
    services: [
      'Sound Design',
      'Consulting'
    ],
    client: 'Ghost Autonomy',
    small: false
  },
  {
    id: 'sumo-ishiki-ep',
    videoUrl: 'videos/hokori_master.mp4',
    title: 'sumo – Ishiki EP',
    subtitle: '',
    link: 'https://sonarkollektiv.lnk.to/Ishiki',
    linkTitle: 'Listen',
    services: [
      'Composition',
      'Production',
      'Mixing',
      'Music Video'
    ],
    client: 'Partners: Mr. Hope · Marcel Müller · Andreas Klassen',
    small: false
  },
  {
    id: 'kolk17',
    videoUrl: 'videos/kolk17_master.mp4',
    title: 'KOLK17',
    subtitle: '',
    services: [
      '4.1 On-Site Mixing'
    ],
    client: 'Jochen Ehmann / Klangerfinder',
    small: true
  },
  {
    id: 'mercedes-museum',
    videoUrl: 'videos/mercedesmuseum_master.mp4',
    title: 'Mercedes-Benz Museum',
    subtitle: '',
    services: [
      'Music',
      'Sound Design'
    ],
    client: '0711 Livecom GmbH',
    small: false
  },
  {
    id: 'mvsp-band',
    videoUrl: 'videos/mvsp_master.mp4',
    title: 'MVSP (Band)',
    subtitle: '',
    link: 'http://www.udiocollective.com/',
    linkTitle: 'Website',
    services: [
      'Composition',
      'Mixing',
      'Mastering'
    ],
    client: 'Partners: Finji · Ondo · Thunderpad',
    small: true
  },
  {
    id: 'roomservice-telephone',
    videoUrl: 'videos/roomservice_master.mp4',
    title: 'Roomservice Telephone Announcement',
    subtitle: '',
    services: [
      'Sound Design',
      'Casting',
      'Voice Recording'
    ],
    client: 'Roomservice GmbH',
    small: false
  },
  {
    id: 'sumo-hoer-mixtape',
    videoUrl: 'videos/hoer_master.mp4',
    title: 'sumo HÖR Mixtape',
    subtitle: '',
    link: 'https://www.youtube.com/watch?v=gv8rrI6vTqM&list=RDgv8rrI6vTqM&start_radio=1&t=1118s',
    linkTitle: 'Watch',
    services: [
      'DJ',
      'Curation'
    ],
    client: 'Partner: HÖR Berlin',
    small: false
  },
  {
    id: 'sumo-be-my-guest',
    videoUrl: 'videos/bemyguest_master.mp4',
    title: 'sumo – Be My Guest Mix',
    subtitle: '',
    link: 'https://soundcloud.com/sumo0711',
    linkTitle: 'LISTEN',
    services: [
      'DJ',
      'Curation'
    ],
    client: 'Partner: BaBa Beach Cloud',
    small: false
  },
  {
    id: 'city-of-kings',
    videoUrl: 'videos/stadtderkoenige_master.mp4',
    title: 'City of Kings',
    subtitle: 'Stuttgart Explained Through 25 Objects',
    link: 'https://www.stadtpalais-stuttgart.de/ausstellungen/stuttgart-stadt-der-koenige',
    linkTitle: 'MORE',
    services: [
      'Casting',
      'Voice Recording',
      'Audio Drama Production'
    ],
    client: 'Partner: StadtPalais Stuttgart',
    small: false
  },
  {
    id: 'sumo-trakul-ep',
    videoUrl: 'videos/trakul_master.mp4',
    title: 'sumo – Trakul EP',
    subtitle: '',
    link: 'https://sonarkollektiv.lnk.to/TrakulEP',
    linkTitle: 'Listen',
    services: [
      'Composition',
      'Production',
      'Mixing'
    ],
    client: 'Partners: Mr. Hope · Marcel Müller',
    small: true
  }
];